import script from "./stock-market-basics-for-beginners-a-guide-to-investing-and-trading.vue?vue&type=script&setup=true&lang=js"
export * from "./stock-market-basics-for-beginners-a-guide-to-investing-and-trading.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__